import get from 'lodash/get'
import { IGeocodingAllowedCountryEnum } from 'types/graphqlTypes'
import { TGeocodingAllowedCountry } from '../types'

/**
 * @example getCountryCodeEnum('US') // IGeocodingAllowedCountryEnum.US
 */
export const getCountryCodeEnum = (
  keyName: TGeocodingAllowedCountry
): IGeocodingAllowedCountryEnum => {
  return get(IGeocodingAllowedCountryEnum, keyName)
}
